import * as React from 'react';
import { RefObject, useCallback } from 'react';

export function useResizeObserver(targetRef: RefObject<HTMLElement>): DOMRect {
  const [rect, setRect] = React.useState<DOMRect | null>(null);

  const callback = useCallback(
    (entries: ResizeObserverEntry[]) => {
      const el = targetRef.current;
      if (!el) {
        return;
      }

      for (const entry of entries) {
        if (entry.target === el) {
          setRect(entry.contentRect);
          return;
        }
      }
    },
    [setRect, targetRef]
  );

  React.useEffect(() => {
    const el = targetRef.current;
    if (!el) {
      setRect(null);
      return;
    }

    const resizeObserver = new ResizeObserver(callback);
    resizeObserver.observe(el);

    return () => {
      resizeObserver.unobserve(el);
      resizeObserver.disconnect();
    };
  }, [targetRef]);

  return rect;
}
